__turbopack_context__.v({
  "amount": "ForwardingOverview-module__ET5GLG__amount",
  "amountAndTextContainer": "ForwardingOverview-module__ET5GLG__amountAndTextContainer",
  "border": "ForwardingOverview-module__ET5GLG__border",
  "bottomContainer": "ForwardingOverview-module__ET5GLG__bottomContainer",
  "card": "ForwardingOverview-module__ET5GLG__card",
  "celebrationImage": "ForwardingOverview-module__ET5GLG__celebrationImage",
  "heading": "ForwardingOverview-module__ET5GLG__heading",
  "importantText": "ForwardingOverview-module__ET5GLG__importantText",
  "largeText": "ForwardingOverview-module__ET5GLG__largeText",
  "summaryText": "ForwardingOverview-module__ET5GLG__summaryText",
  "topContainer": "ForwardingOverview-module__ET5GLG__topContainer",
});
